import moment from 'moment-timezone';
export const GET_VIRTUAL_EVENTS_REQUEST = 'GET_VIRTUAL_EVENTS_REQUEST';
export const GET_VIRTUAL_EVENTS_FAILURE = 'GET_VIRTUAL_EVENTS_FAILURE';
export const GET_VIRTUAL_EVENTS_SUCCESS = 'GET_VIRTUAL_EVENTS_SUCCESS';
export const TOGGLE_VIRTUAL_EVENT = 'TOGGLE_VIRTUAL_EVENT';
export const TOGGLE_ALL_VIRTUAL_EVENTS = 'TOGGLE_ALL_VIRTUAL_EVENTS';
export const FILTER_VIRTUAL_EVENTS = 'FILTER_VIRTUAL_EVENTS';
export const RESET_FILTER_SELECTED_VIRTUAL_EVENT_KEY = 'FILTER_SELECTED_VIRTUAL_EVENT_KEY';

export function resetVirtualSelectedVirtualEventKeyAction() {
  return {
    type: RESET_FILTER_SELECTED_VIRTUAL_EVENT_KEY
  };
}

export function getVirtualEvents(
  fromTime = moment()
    .subtract(1, 'year')
    .startOf('day')
    .toISOString(),
  toTime = moment()
    .add(1, 'year')
    .endOf('day')
    .toISOString()
) {
  return {
    type: GET_VIRTUAL_EVENTS_REQUEST,
    payload: { fromTime, toTime }
  };
}

export function toggleVirtualEvent(virtualEventKey, isSelected) {
  return {
    type: TOGGLE_VIRTUAL_EVENT,
    payload: { virtualEventKey, isSelected }
  };
}

export function toggleAllVirtualEvents(isSelected = true) {
  return {
    type: TOGGLE_ALL_VIRTUAL_EVENTS,
    payload: { isSelected }
  };
}

export function filterVirtualEvents(filterOptions) {
  const { searchString, registrantRange } = filterOptions;
  return {
    type: FILTER_VIRTUAL_EVENTS,
    payload: { searchString, registrantRange }
  };
}



// WEBPACK FOOTER //
// ./src/Reducks/VirtualEvents/VirtualEventsActions.js